(() => {
  'use strict';

  // Shows the sticky mobile buy bar (see sections/meningea-product.liquid) once the real
  // Add to Cart button has scrolled off the top of the screen, and hides it again over the
  // footer so it never sits on top of the legal notices or the withdrawal function.
  //
  // Deliberately does nothing until the button has left *upwards*. While it is merely still
  // below the fold the page is already leading somewhere — covering the description with a
  // second button at that point would be nagging, not helping.

  const bar = document.querySelector('[data-buybar]');
  const anchor = document.querySelector('.meningea-product__submit');
  if (!bar || !anchor || !('IntersectionObserver' in window)) return;

  const mq = window.matchMedia('(max-width: 749px)');
  const footer = document.querySelector('.meningea-footer');

  let anchorPassed = false;
  let footerVisible = false;
  let shown = null;

  function apply() {
    const next = mq.matches && anchorPassed && !footerVisible;
    if (next === shown) return;
    shown = next;
    bar.classList.toggle('is-visible', next);
    bar.setAttribute('aria-hidden', next ? 'false' : 'true');
  }

  new IntersectionObserver(
    ([entry]) => {
      anchorPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      apply();
    },
    { threshold: 0 }
  ).observe(anchor);

  if (footer) {
    new IntersectionObserver(
      ([entry]) => {
        footerVisible = entry.isIntersecting;
        apply();
      },
      { threshold: 0 }
    ).observe(footer);
  }

  mq.addEventListener('change', apply);
  apply();
})();
